'use client'

import { ScrollProgress } from './effects'
import { Navigation } from './navigation'
import { Footer } from './footer'

export function SiteShell({
  children,
  showNav = true,
  showFooter = true,
}: {
  children: React.ReactNode
  showNav?: boolean
  showFooter?: boolean
}) {
  return (
    <main className="relative min-h-screen bg-background text-foreground">
      <ScrollProgress />
      {showNav && <Navigation />}
      {children}
      {showFooter && <Footer />}
    </main>
  )
}
